/* theme_custom.Shopify.formatMoney(100, theme_custom.money_format) */
theme_custom.Shopify = {
  formatMoney: function formatMoney(t, r) {
    function e(t, r) {
      return void 0 === t ? r : t;
    }

    function a(t, r, a, o) {
      if (r = e(r, 2), a = e(a, ","), o = e(o, "."), isNaN(t) || null == t) return 0;
      t = (t / 100).toFixed(r);
      var n = t.split(".");
      return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (n[1] ? o + n[1] : "");
    }

    "string" == typeof t && (t = t.replace(".", ""));
    var o = "",
      n = /\{\{\s*(\w+)\s*\}\}/,
      i = r || this.money_format;

    switch (i.match(n)[1]) {
      case "amount":
        o = a(t, 2);
        break;

      case "amount_no_decimals":
        o = a(t, 0);
        break;

      case "amount_with_comma_separator":
        o = a(t, 2, ".", ",");
        break;

      case "amount_with_space_separator":
        o = a(t, 2, " ", ",");
        break;

      case "amount_with_period_and_space_separator":
        o = a(t, 2, " ", ".");
        break;

      case "amount_no_decimals_with_comma_separator":
        o = a(t, 0, ".", ",");
        break;

      case "amount_no_decimals_with_space_separator":
        o = a(t, 0, " ", "");
        break;

      case "amount_with_apostrophe_separator":
        o = a(t, 2, "'", ".");
        break;

      case "amount_with_decimal_separator":
        o = a(t, 2, ".", ".");
    }

    return i.replace(n, o);
  },
  formatImage: function formatImage(originalImageUrl, format) {
    return originalImageUrl.replace(/^(.*)\.([^\.]*)$/g, '$1_' + format + '.$2');
  },
  Image: {
    imageSize: function imageSize(t) {
      var e = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
      return null !== e ? e[1] : null;
    },
    getSizedImageUrl: function getSizedImageUrl(t, e) {
      if (null == e) return t;
      if ("master" == e) return this.removeProtocol(t);
      var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

      if (null != o) {
        var i = t.split(o[0]),
          r = o[0];
        return this.removeProtocol(i[0] + "_" + e + r);
      }

      return null;
    },
    removeProtocol: function removeProtocol(t) {
      return t.replace(/http(s)?:/, "");
    }
  }
};

$(document).ready(function(){
  var maxQty = parseInt($('.quantity-cart').text()) || 0;
  let selectedVar = '';
  $('variant-selects .product-form__input').each(function() {
    let checkedValue = $(this).find('input:checked').val();
    if (checkedValue) {
      selectedVar += checkedValue + ' / ';
    }
  });
  if (selectedVar.endsWith(' / ')) {
    selectedVar = selectedVar.slice(0, -3);
  }
  var dataAvailQty = parseFloat($(`.custom_product_variants option[data-val='${selectedVar}']`).attr('data-avail-qty'));
  var setMaxQty = parseFloat($('.max_qty_num').attr('data-max'));
  if(dataAvailQty < setMaxQty){
    setMaxQty = dataAvailQty;
  }
  
  if(maxQty > setMaxQty-1){
    $('.product-form__submit').addClass('disabled');
    $('.product-form__quantity .quantity__button[name="plus"]').addClass('disabled hidden');
    $('.product-form__quantity .custom_qty_sub').removeClass('hidden');
  }else{
    $('.product-form__submit').removeClass('disabled');
  }

  
  
  $(document).on('click', '.product-form__quantity .custom_qty_sub', function(e){
    e.preventDefault();
    $('.qty__err').removeClass('hidden');
  });
  
  theme_custom.defaultQty();
});


theme_custom.defaultQty = function(){
  var quantity = parseInt($(this).find('input').val()) || 1;
  var updatedQty = parseInt($('.quantity-cart').text()) || 0;
  var maxQty = quantity + updatedQty;
  
  let selectedVar = '';
  $('variant-selects .product-form__input').each(function() {
    let checkedValue = $(this).find('input:checked').val();
    if (checkedValue) {
      selectedVar += checkedValue + ' / ';
    }
  });
  if (selectedVar.endsWith(' / ')) {
    selectedVar = selectedVar.slice(0, -3);
  }
  var dataAvailQty = parseFloat($(`.custom_product_variants option[data-val='${selectedVar}']`).attr('data-avail-qty'));
  var setMaxQty = parseFloat($('.max_qty_num').attr('data-max'));
  if(dataAvailQty < setMaxQty){
    setMaxQty = dataAvailQty;
  }
  
  if(maxQty > setMaxQty-1){
    $('.product-form__quantity .quantity__button[name="plus"]').addClass('disabled');
  }else{
    $('.product-form__quantity.quantity__button[name="plus"]').removeClass('disabled');
  }
}